module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "card-header"
  }, [_vm._v("\n      " + _vm._s(_vm.todo.project) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_vm._v("\n          " + _vm._s(_vm.todo.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "extra content"
  }, [_c('span', {
    staticClass: "right floated edit icon",
    on: {
      "click": _vm.showForm
    }
  }, [_c('i', {
    staticClass: "edit icon"
  })]), _vm._v(" "), _c('span', {
    staticClass: "right floated trash icon",
    on: {
      "click": function($event) {
        _vm.deleteTodo(_vm.todo)
      }
    }
  }, [_c('i', {
    staticClass: "trash icon"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "card-header"
  }, [_c('label', {
    staticClass: "d-none"
  }, [_vm._v("Project")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todo.project),
      expression: "todo.project"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.todo.project)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.todo.project = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "d-none"
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todo.title),
      expression: "todo.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.todo.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.todo.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "btn btn-warning btn-block btn-noradiusTop",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideForm
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Close ×")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing && _vm.todo.done),
      expression: "!isEditing &&todo.done"
    }],
    staticClass: "btn btn-success btn-noradiusTop",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n        Completed\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing && !_vm.todo.done),
      expression: "!isEditing && !todo.done"
    }],
    staticClass: "btn btn-secondary btn-noradiusTop",
    on: {
      "click": function($event) {
        _vm.completeTodo(_vm.todo)
      }
    }
  }, [_vm._v("\n        Pending\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a0b212a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todo.vue
// module id = 94
// module chunks = 0